import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { USER } from '../../data/reducer';
import Api from '../../api/Api';
import Row from '../tag/Row';
import { FormattedMessage } from 'react-intl';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';
import OTIcon from '../tag/OTIcon';
import Alert from '../Alert';
import { updateUserInfo } from '../../data/user/profile/actions';
import { selectIsHpa } from '../../data/hpa/selectors';
import {OTLink} from "../tag/OTLink";

const { id: module_id } = module;

class BioBankAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShown: true,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    let { userInfo } = this.props;
    if (userInfo.bioBankAgreement != null) {
      if (userInfo.bioBankAgreement == true || get(this.props, 'isHpa')) {
        this.setState({ isShown: false });
      }
    }
  }

  handleChange() {
    Api.updateBioBankAgreement({ payload: true })
      .then(() => {
        this.props.updateUserInfo();
      })
      .catch((err) => {
        console.log(err);
      });
    this.setState({ isShown: false });
  }

  render() {
    const { isShown } = this.state;
    return (
      <div>
        {isShown ? (
          <Alert
            type="info"
            style={{ padding: '20px' }}
            className="biobank_alert"
          >
            <Row>
              <div style={{ marginBottom: '10px' }}>
                <OTIcon
                  config={{
                    type: 'custom',
                    color: 'darkblue',
                    name: 'sopimus',
                  }}
                />
                <h1 className="biobank_alert_title">
                  <FormattedMessage id={`${module_id}.title`} />
                </h1>
                <button
                  className="alert-dismiss pull-right"
                  onClick={this.handleChange}
                  style={{ color: '#073184' }}
                >
                  <i className="alert-dismiss icon-remove pull-right" />
                </button>
              </div>
              <p>
                <FormattedMessage id={`${module_id}.content`} />
              </p>
              <p>
                <FormattedMessage id={`${module_id}.content.plus`} />
              </p>
              <p>
                <OTLink
                  className="biobank_alert_services_readinfo_link"
                  isExternal={true}
                  target="_blank"
                  link={
                    'https://www.pirha.fi/biopankkipalvelut-kansalaisille'
                  }
                >
                  <FormattedMessage id={`${module_id}.biobank.services.readinfo.link`}>
                    {(txt) => <>{txt}</>}
                  </FormattedMessage>
                  <OTIcon
                    config={{
                      type: 'fa',
                      name: 'icon-external-link',
                      color: 'default',
                    }}
                  />
                </OTLink>
              </p>
              <p>
                <OTLink
                  className="biobank_alert_sample_collection_readinfo_link"
                  isExternal={true}
                  target="_blank"
                  link={
                    'https://pirha.fi/documents/d/kehitysversio/biopankin-naytekerays-toimenpiteen-yhteydessa-v3-0'
                  }
                >
                  <FormattedMessage id={`${module_id}.biobank.sample.collection.readinfo.link`}>
                    {(txt) => <>{txt}</>}
                  </FormattedMessage>
                  <OTIcon
                    config={{
                      type: 'fa',
                      name: 'icon-external-link',
                      color: 'default',
                    }}
                  />
                </OTLink>
              </p>
              <p>
                <strong>
                  <FormattedMessage id={`${module_id}.footer`} />
                </strong>
              </p>
            </Row>

            <Row>
              <OTButtonGroup type={'big'} expectedCount={1} collapseOnMobile>
                <OTButton key="submit" onClick={this.handleChange}>
                  <FormattedMessage id={`close.alert`} />
                </OTButton>
              </OTButtonGroup>
            </Row>
          </Alert>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state[USER].userInfo,
    isHpa: selectIsHpa(state),
  };
};

export default connect(mapStateToProps, { updateUserInfo })(BioBankAlert);
